import SiteHeader from "@/pages/home/components/SiteHeader";
import NewsTicker from "@/pages/home/components/NewsTicker";
import HeroSection from "@/pages/home/components/HeroSection";
import LatestUpdatesSection from "@/pages/home/components/LatestUpdatesSection";
import TimelineSection from "@/pages/home/components/TimelineSection";
import OfficialNoticesSection from "@/pages/home/components/OfficialNoticesSection";
import EvidenceSection from "@/pages/home/components/EvidenceSection";
import TopicsSection from "@/pages/home/components/TopicsSection";
import DownloadBanner from "@/pages/home/components/DownloadBanner";
import FaqSection from "@/pages/home/components/FaqSection";
import SiteFooter from "@/pages/home/components/SiteFooter";

export default function Home() {
  return (
    <div className="min-h-screen bg-background-50 font-body text-foreground-950">
      <SiteHeader />
      <main>
        <NewsTicker />
        <HeroSection />
        <LatestUpdatesSection />
        <TimelineSection />
        <OfficialNoticesSection />
        <EvidenceSection />
        <TopicsSection />
        <DownloadBanner />
        <FaqSection />
      </main>
      <SiteFooter />
    </div>
  );
}